/**
 *
 * LocationMarker
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
// import styled from 'styled-components';
import { Marker } from 'react-leaflet';

import withRoute from 'containers/withRoute';
import { PATH_LOCATION } from 'containers/App/constants';
import MenuInfoWindow from 'components/InfoWindow/MenuInfoWindow';
import clubIconImage from 'images/icons/yellow_r.png';
import leafletIcon from 'utils/leafletIcon';
import { DIMMED_MARKER_OPACITY } from '../Map/constants';

class LocationMarker extends React.PureComponent {
  constructor(props) {
    super(props);
    this.icon = leafletIcon({ iconUrl: clubIconImage });
  }

  render() {
    const { loc, goTo, dimmed } = this.props;
    const title = loc.clubs.map(club => club.name).join(', ');
    const menu = loc.clubs.map(club => ({
      id: club.id,
      label: club.name,
      action: () =>
        goTo(PATH_LOCATION, {
          clubId: loc.clubs[0].id,
          locationId: loc.id,
        }),
    }));
    const oneClub = loc.clubs.length === 1;
    const handleClick = oneClub ? menu[0].action : undefined;
    return (
      <Marker
        title={title}
        position={loc}
        icon={this.icon}
        onClick={handleClick}
        opacity={dimmed ? DIMMED_MARKER_OPACITY : 1}
      >
        {!oneClub && <MenuInfoWindow menu={menu} />}
      </Marker>
    );
  }
}

LocationMarker.propTypes = {
  loc: PropTypes.object.isRequired,
  goTo: PropTypes.func.isRequired,
  dimmed: PropTypes.bool,
};

export default withRoute(LocationMarker);
